module.exports = __webpack_public_path__ + "static/media/liebrecht-haas-logo.2f45ce35.png";